"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformUserParsedResponse = exports.transformUserResponse = void 0;
/* eslint-disable @typescript-eslint/camelcase */
const Error_1 = require("./Error");
const PhoneNumber_1 = require("./PhoneNumber");
const Address_1 = require("./Address");
const BusinessMembership_1 = require("./BusinessMembership");
const Role_1 = require("./Role");
const Profession_1 = require("./Profession");
const Group_1 = require("./Group");
function transformUserResponse(data, headers, status) {
    const response = JSON.parse(data);
    if ((0, Error_1.isAuthErrorResponse)(status, response)) {
        return (0, Error_1.transformAuthErrorResponse)(response);
    }
    const user = response.response;
    return transformUserParsedResponse(user);
}
exports.transformUserResponse = transformUserResponse;
function transformUserParsedResponse(user) {
    return {
        id: user.id.toString(),
        firstName: user.first_name,
        lastName: user.last_name,
        email: user.email,
        phoneNumbers: user.phone_numbers &&
            user.phone_numbers.map((phoneNumber) => (0, PhoneNumber_1.transformPhoneNumberParsedResponse)(phoneNumber)),
        permissions: user.permissions,
        subscriptionStatuses: user.subscription_statuses,
        businessMemberships: user.business_memberships &&
            user.business_memberships.map((membership) => (0, BusinessMembership_1.transformBusinessMembershipParsedResponse)(membership)),
        roles: user.roles && user.roles.map((role) => (0, Role_1.transformRoleParsedResponse)(role)),
        addresses: user.addresses &&
            user.addresses
                .filter((address) => address !== null)
                .map((address) => (0, Address_1.transformAddressParsedResponse)(address)),
        profession: user.profession && (0, Profession_1.transformProfessionParsedResponse)(user.profession),
        groups: user.groups && user.groups.map((group) => (0, Group_1.transformGroupParsedResponse)(group)),
        links: user.links,
    };
}
exports.transformUserParsedResponse = transformUserParsedResponse;
//# sourceMappingURL=User.js.map